import UserControlForm from '../UserControl/UserControlForm';

export default function Profile() {
  return <UserControlForm currentUser />;
}
